import { UUID } from '@/types';
import React, { FC } from 'react';
import { TrevorLink } from '@/components/TrevorLink';
import { Label, Tooltip } from '@trevor/ui-components';
import { Permission } from '@/permissions/Permission';
import styled from 'styled-components';

const goBackTooltipId = 'go-back-tooltip-id';

type DashboardBreadcrumb = {
  datasourceId: UUID;
  dashboardId: UUID;
  title: string;
  onTitleClick: F<React.MouseEvent>;
};

const Title = styled(Label).attrs({ variant: 2 })`
  cursor: pointer;
  font-weight: bold;
`;

const DashboardBreadcrumbContainer = styled.div`
  display: inline-flex;
`;
export const DashboardBreadcrumb: FC<DashboardBreadcrumb> = ({
  title,
  datasourceId,
  dashboardId,
  onTitleClick,
}) => {
  return (
    <DashboardBreadcrumbContainer>
      <TrevorLink to="..">
        <Label variant={2} data-tooltip-id={goBackTooltipId}>
          Dashboards
        </Label>
        <Tooltip id={goBackTooltipId}>Back to dashboards</Tooltip>
      </TrevorLink>
      <Permission
        permissionPath={`${datasourceId}.dashboards.${dashboardId}.write`}
        fallback={<Title>&nbsp;/&nbsp;{title}</Title>}
      >
        <Title onClick={onTitleClick}>&nbsp;/&nbsp;{title}</Title>
      </Permission>
    </DashboardBreadcrumbContainer>
  );
};
